import { createContext, useContext } from 'react';

import { MarketplaceLead } from '~/types/marketplace';

type LeadContextType = {
  lead: MarketplaceLead | null;
};

export const LeadContext = createContext<LeadContextType>({
  lead: null,
});

export const LeadProvider = ({ lead, children }: LeadContextType & { children: React.ReactNode }) => {
  return <LeadContext.Provider value={{ lead }}>{children}</LeadContext.Provider>;
};

export const useLeadContext = () => {
  const context = useContext(LeadContext);
  if (context === undefined) {
    throw new Error('useLeadContext must be used within a LeadProvider');
  }
  return context;
};
